import { connect } from "knockout-store";
import { htmlModalClass } from "../utils/functions";
import { r } from "../utils/routing";

function appViewModel(params) {
  const vm = {};

  vm.escapeHandler = () => {
    params.modal("");
    params.popUp("");
  };

  vm.appClass = () => {
    if (
      (params.route() === r("storyline") || params.route() === r("database")) &&
      params.modal() !== ""
    ) {
      htmlModalClass(true, "modal");
      document.addEventListener("keydown", vm.escapeHandler);
      return "has-modal-open";
    } else if (
      (params.route() === r("storyline") || params.route() === r("database")) &&
      params.popUp() !== ""
    ) {
      htmlModalClass(true, "pop-up");
      document.addEventListener("keydown", vm.escapeHandler);
      return "has-pop-up-open";
    } else {
      htmlModalClass(false);
      document.removeEventListener("keydown", vm.escapeHandler);
      return "";
    }
  };
  return vm;
}

function mapStateToParams({ modal, popUp, route }) {
  return { modal, popUp, route };
}

export default connect(mapStateToParams)(appViewModel);
